import { render } from "./FooterComponent.vue?vue&type=template&id=da6ae670&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=da6ae670&scoped=true&lang=css"

import exportComponent from "/Users/ayarmots/MyDev/youtest.ru/youtest-front-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da6ae670"]])

export default __exports__